import { render, staticRenderFns } from "./FEllipsis.vue?vue&type=template&id=51e1a0e9&"
import script from "./FEllipsis.vue?vue&type=script&lang=js&"
export * from "./FEllipsis.vue?vue&type=script&lang=js&"
import style0 from "./FEllipsis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports